import { yup } from '@framework/validation';
import { getWidgetName } from '../../../../../validator';
import { IInputWidget } from '../IInputWidget';

export function createCommonFormSchema<W extends IInputWidget>(
  schema: yup.AnySchema,
  widget: W,
) {
  return { [getWidgetName(widget)]: schema };
}
